// Page layout of a Major-style Swiss stage (admin StagePage + public page), like HLTV's event
// page: "Playoffs" on top, "Group play" below, both collapsible. Group play = the record graph
// (MajorSwissView) or, with "Detailed view", the round columns + standings (SwissView).
// The switch is remembered in this browser.
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MajorSwissView from './MajorSwissView';
import SwissView from './SwissView';
import './bracket.css';

const VIEW_KEY = 'fluxbot_major_view';

function Section({ title, extra, children, defaultOpen = true }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="br-card mj-section">
      <div className="mj-section-head">
        <h3>{title}</h3>
        {open && extra}
        <button type="button" className="mj-collapse" onClick={() => setOpen(o => !o)} aria-expanded={open}
          title={open ? t('bracket.major.collapse', 'Collapse') : t('bracket.major.expand', 'Expand')}>{open ? '▲' : '▼'}</button>
      </div>
      {open && <div className="mj-section-body">{children}</div>}
    </div>
  );
}

/** playoffs: node shown in the Playoffs section (null = no playoffs); settings: node above the graph (admin). */
export default function MajorStageLayout({ playoffs, settings, bracket, matches, teams, standings, readOnly, selectedId, onSelect, onSwap, linkPrefix }) {
  const { t } = useTranslation();
  const [view, setView] = useState(() => { try { return localStorage.getItem(VIEW_KEY) === 'detailed' ? 'detailed' : 'graph'; } catch (_) { return 'graph'; } });
  const pick = (v) => { setView(v); try { localStorage.setItem(VIEW_KEY, v); } catch (_) { } };
  const props = { bracket, matches, teams, standings, readOnly, selectedId, onSelect, onSwap, linkPrefix };

  return (
    <>
      {playoffs && <Section title={t('bracket.po.title', 'Playoffs')}>{playoffs}</Section>}
      <Section title={t('bracket.major.groupPlay', 'Group play')}
        extra={(
          <span className="mj-switch" role="tablist">
            <button type="button" role="tab" aria-selected={view === 'graph'} className={view === 'graph' ? 'on' : ''} onClick={() => pick('graph')}>{t('bracket.major.graph', 'Graph')}</button>
            <button type="button" role="tab" aria-selected={view === 'detailed'} className={view === 'detailed' ? 'on' : ''} onClick={() => pick('detailed')}>{t('bracket.major.detailed', 'Detailed view')}</button>
          </span>
        )}>
        {settings}
        {view === 'graph' ? <MajorSwissView {...props} /> : <SwissView {...props} />}
      </Section>
    </>
  );
}
